<script>
    import QuestionText from "../QuestionText/QuestionText.svelte";
    import Separator from "../Separator/Separator.svelte";
    import {txt} from '../../i18n/i18n';  
   
    /** @type {Question} */
    export let question;
    /** @type {Number} - The question number, starting on 1 */
    export let number;
</script>

<Separator />
<div class="questionresult-container">
    <h3 class="question-heading">{txt('Question_x', [number])}</h3>
    <QuestionText {question}></QuestionText>

    <slot>

    </slot>
</div>
